<nav aria-label="breadcrumb" *ngIf="breadcrumbs.length">
  <ol class="breadcrumb">
    <li *ngFor="let bc of breadcrumbs" class="breadcrumb-item">
      <a [routerLink]="bc.url">{{ bc.label }}</a>
    </li>
  </ol>
</nav>
